<ng-container>

  <div class="alert warning">
    <p>{{ error }}</p>
  </div>
</ng-container>
